import React, {useEffect, useLayoutEffect, useState} from "react";
import s from "./TextEditorOnboarding.module.css";
import character from "../../../../assets/img/character.svg";
import { useSelector } from "react-redux";
import {selectCurrentStep, selectIsPreviewVisible} from "../../../../store/selectors/projectSelectors";
import { useAppDispatch } from "../../../../store/store";
import {setCurrentStep, setIsPostButtonVisible, setIsPromptBodyVisible} from "../../../../store/slices/projectSlice";
import close from '../../../../assets/img/close.svg'
interface StepContent {
    text: string;
    image: string;
    position: { top: string; left: string }; // Позиция шага
    isButtonDisabled: boolean;
}

const TextEditorOnboarding: React.FC = () => {
    const currentStep=useSelector(selectCurrentStep)
    const [isOnboardingComplete, setIsOnboardingComplete] = useState(false);
    const [isOnboardingVisible, setIsOnboardingVisible] = useState(true);
    const isPreviewVisible = useSelector(selectIsPreviewVisible);
    const dispatch = useAppDispatch();

    useLayoutEffect(() => {
        const onboardingComplete = localStorage.getItem('isOnboardingComplete') === 'true';
        if (onboardingComplete) {
            setIsOnboardingVisible(false);
            dispatch(setIsPostButtonVisible(true));
        }
    }, []);

    const steps: StepContent[] = [
        {
            text: "Welcome to the editor—time to make your content uniquely yours!",
            image: character,
            position: { top: "250px", left: "10%" },
            isButtonDisabled: false,
        },
        {
            text: "Tap ‘Preview post’ above to see it come to life!",
            image: character,
            position: { top: "400px", left: "75%" },
            isButtonDisabled: !isPreviewVisible,
        },
        {
            text: "Great! Ready to post it?",
            image: character,
            position: { top: "400px", left: "75%" },
            isButtonDisabled: false,
        },
        {
            text: "Awesome! Let’s create a different prompt. Type above and click ‘Generate’ or click next to skip that part.",
            image: character,
            position: { top: "250px", left: "10%" },
            isButtonDisabled: false,
        },
        {
            text: "Let’s add some tone and style, click on the ‘main text’ to start customizing!",
            image: character,
            position: { top: "250px", left: "10%" },
            isButtonDisabled: true,
        },
        {
            text: "Nice work! That looks amazing—let’s jump into the fun part now!",
            image: character,
            position: { top: "530px", left: "7%" },
            isButtonDisabled: false,
        },
        {
            text: "Let’s create a stunning image to make your content shine!\n" +
                "\n" +
                "Click the image icon to begin",
            image: character,
            position: { top: "330px", left: "7%" },
            isButtonDisabled: false,
        },
    ];

    const handleNext = () => {
        if (currentStep < steps.length) {
            if(currentStep===3){
                dispatch(setIsPostButtonVisible(true));
            }
            console.log(currentStep);
            if(currentStep==6){
                dispatch(setIsPromptBodyVisible(false))

            }
            dispatch(setCurrentStep(currentStep+1))

        } else {
            handleCompleteOnboarding()

        }
    };
    const handleCompleteOnboarding = () => {
        setIsOnboardingComplete(true);
        localStorage.setItem('isOnboardingComplete', 'true');
    };

    const handleShowPostButton = () => {
        dispatch(setIsPostButtonVisible(true));
        handleCompleteOnboarding()
    };
    const handleClose = () => {
        setIsOnboardingVisible(false);
        handleCompleteOnboarding()
        dispatch(setIsPostButtonVisible(true));
    };

    const currentContent = steps[currentStep - 1];
    if (!isOnboardingVisible) {
        return null;
    }
    if (isOnboardingComplete) {
        return <div className={s.container} style={{
            position: "absolute",
            top: "400px", left: "73%",
            height:'150px'

        }}>
            <img src={ close} className={s.close} onClick={handleClose}/>
            <img
                src={currentContent.image}
                className={s.image}
            />
            <p className={s.text}>
                Well done, your post is ready!
            </p>

        </div>
    }

    return (
        <div
            className={s.container}
            style={{
                position: "absolute",
                top: currentContent.position.top,
                left: currentContent.position.left,


            }}
        >   <img src={close} className={s.close} onClick={handleClose}/>
            <img
                src={currentContent.image}
                alt={`Step ${currentStep}`}
                className={s.image}
            />
            <p className={s.text}>{currentContent.text}</p>
            {currentStep === 3 && (
                <button
                    className={s.white_button}
                    onClick={handleShowPostButton}
                    disabled={currentContent.isButtonDisabled}
                >
                    Yes!
                </button>
            )}
            {!currentContent.isButtonDisabled && (
                <button
                    className={s.button}
                    onClick={handleNext}
                    disabled={currentContent.isButtonDisabled}
                >
                    {currentStep === 3 ? "Not yet, let’s edit." : "Next"}
                </button>
            )}
        </div>
    );
};

export default TextEditorOnboarding;
